import Vue from 'vue'
import { decode, formatMoney, getProductFullName, formatPrice } from '@/lib/util'
import { setRecentlyViewed } from '@/lib/recently-viewed'
import { on } from 'dom-event'
import '../product-gallery/product-gallery.vue'
import '../product-detail/product-detail.vue'
import '../reviews-rating/reviews-rating.vue'
import '../carousel-swiper/carousel-swiper.vue'
import '../product-form-bar/product-form-bar.vue'

export default el => new Vue({
  name: 'Product Main',
  el,
  data() {
    const initialProduct = el.getAttribute('initial-product')
    const rebuyWidgetId = el.dataset?.rebuyWidgetId
    return {
      widgetId: rebuyWidgetId,
      product: JSON.parse(decode(initialProduct)) || null
    }
  },
  methods: {
    getProductFullName,
    saveToRecentlyViewedProducts() {
      if (!this.product) return
      setRecentlyViewed(this.product.handle)
    }
  },
  mounted () {
    this.$el.style.minHeight = 'auto'
    this.saveToRecentlyViewedProducts()
    const selectedOrFirstAvailableVariant = this.product.selectedOrFirstAvailableVariant
    const selectedVariantPrice = formatPrice(selectedOrFirstAvailableVariant?.price)

    const productVariantName = selectedOrFirstAvailableVariant?.title
    const originalEvent = {
      event: 'productDetailView',
      currency: 'USD',
      productID: this.product.id,
      productName: this.getProductFullName(
        this.product.title,
        productVariantName
      ),
      productCategory: this.product.productType,
      productBrand: this.product.vendor,
      productVariantID: selectedOrFirstAvailableVariant?.id,
      productVariantName,
      productPrice: selectedVariantPrice,
    }
    /**
     * Build shape of dataLayer required for Ecommerce Measurement: detail
     * Accepts Data: list, array of productFieldObjects
     * @see https://developers.google.com/analytics/devguides/collection/ua/gtm/enhanced-ecommerce#details
     */
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: originalEvent.event,
      ecommerce: {
        detail: {
          products: [
            {
              name: originalEvent.productName,
              id: originalEvent.productID,
              price: originalEvent.productPrice,
              brand: originalEvent.productBrand,
              category: originalEvent.productCategory,
              variant: originalEvent.productVariantName,
            },
          ],
        },
      },
    })
    const _this = this
    document.addEventListener('rebuy.init', function () {
      on(window, 'resize', () => {
        if (!_this.widgetId) return
        setTimeout(() => {
          const widget = window.Rebuy.widgets.find(widget => widget.id === _this.widgetId)
          if (!widget) return
          widget.View.carousel.options.adaptiveHeight = true
          widget.View.carousel.options.resize = true
          widget.View.carousel.options.watchCSS = true
          widget.View.carousel.resize()
        }, 500)
      })
    })
  }
})